import { initSetProducts } from './setProducts'

export function initDetail() {
    console.log('Detail initialized!')
    initSetProducts()

    if (!$('.set-products-loaded').length) {
        $('.p-basic-info-block .block:has(.availability-label), .p-final-price-wrapper').addClass('ready')
    }
}
